import { Colors } from "../../../consts/Colors";
import ButtonRounded from "../../global/buttons/ButtonRounded";
import InputText from "../../global/InputText";
import QuestionPanel from "./QuestionPanel";
export default class QuestionPanel_1 extends QuestionPanel {
    constructor(scene, x, y, {config, totQuestion}) {
        super(scene, x, y, {
            numquestion: 1,
            totQuestion,
            question: config.question,
            textIndice: config.indice
        });

        // Ajout input texte
        this.inputText = new InputText(this.scene, this.width /2, this.sousTitreText.y + this.sousTitreText.height + 32 + 32, {
            placeholder: "Entrez votre réponse ...",
            width: 410,
            height: 64
        })
        this.add(this.inputText)
        this.inputText.setOnUpdateFunction( (input, text) => {
            if(text.length > 0){
                this.validateButton.setUnlocked();
                this.validateButton.background.setFillStyle(Colors.Elmt.Orange)
            }else{
                this.validateButton.setLocked();
                this.validateButton.background.setFillStyle(Colors.Elmt.Grey)
            }
        })

        // Ajout bouton valider
        this.validateButton = new ButtonRounded(this.scene, this.width /2, this.inputText.y + this.inputText.height/2 + 24, {
            text: "Valider ma réponse",
            color: Colors.Elmt.Orange,
            hoverColor: Colors.Elmt.Blue,
            textColor: Colors.Text.White,
        })
        this.add(this.validateButton)
        this.validateButton.y+= this.validateButton.height/2
        this.validateButton.setClickFunction( () => {
            // On bloque tous les éléments du panneau
            this.setLocked()

            // On vérifie la réponse
            const isTrue = this.compareText(this.inputText.getInputTextValue().toLowerCase(), config.reponses);
            if(isTrue || this.tentative >= this.maxTentative){
                this.scene.showReponsePopUp({
                    text: config.correction,
                    isTrue: isTrue,
                    endFunc: () => {
                        this.scene.closePanelQuestion((scene) => {scene.addQuestionPanel2();});
                        this.scene.closeReponsePopUp();
                    }
                });
            }else{
                this.scene.cameras.main.shake(200, 0.01);
                this.tentative++;
                this.inputText.iconClose.emit('pointerup'); // On vide l'input
                this.setUnlocked();
            }
        })
        this.validateButton.setLocked()
        this.validateButton.background.setFillStyle(Colors.Elmt.Grey)
    }


    setLocked(){
        super.setLocked();
        this.inputText.setLocked();
        this.validateButton.setLocked();
    }

    setUnlocked(){
        super.setUnlocked();
        this.inputText.setUnlocked();
        this.validateButton.setUnlocked();
    }

    compareText(inputText, reponses){
        let reponse = inputText.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        let isTrue = false

        console.log("compareText", reponse, reponses)

        // On vérifie que la réponse est correcte
        // Donc que seules les réponses sont contenues dans le texte rentré
        reponses.forEach( (ans) => {
        console.log("compareText", reponse, ans, reponse.includes(ans))

            if(reponse.includes(ans)){

                isTrue = true;

                reponse = reponse.replace(ans, ''); // On enlève la bonne réponse du texte

                if(reponse.length === 0){
                    return; // Si le texte est vide, c'est que toutes les réponses sont bonnes
                }
            }
        });

        return isTrue && reponse.length === 0; // Si le texte n'est pas vide, c'est que le joueur a rentré des éléments en plus de la réponse, donc c'est faux
    }
}